/**
 * Stats (statistika) Zod schemalar
 *
 * Kanonik:
 *   - Sana ISO YYYY-MM-DD format (UTC kun chegarasi)
 *   - Period: today, week, month, year, custom
 *   - Pul UZS so'm (Number, lekin Decimal-safe — server tomonida)
 */
import { z } from 'zod';
import { uuidSchema } from './common.schema.js';
// ─── Period enum ──────────────────────────────────────────────────
export const statsPeriodEnum = z.enum(['today', 'yesterday', 'week', 'month', 'year', 'custom']);
// ─── Stats query (umumiy) ─────────────────────────────────────────
export const statsQuerySchema = z
    .object({
    period: statsPeriodEnum.default('today'),
    from: z.string().datetime().optional(), // custom uchun
    to: z.string().datetime().optional(),
    storeId: uuidSchema.optional(),
    userId: uuidSchema.optional(),
})
    .refine((data) => {
    if (data.period === 'custom') {
        return data.from !== undefined && data.to !== undefined;
    }
    return true;
}, { message: 'Custom period uchun from va to kerak', path: ['from'] });
// ─── Top products query ───────────────────────────────────────────
export const topProductsQuerySchema = z.object({
    period: statsPeriodEnum.default('month'),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(10),
    storeId: uuidSchema.optional(),
});
//# sourceMappingURL=stats.schema.js.map